"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NFA = void 0;
var NFA = /** @class */ (function () {
    /** @constructor */
    function NFA(start, end) {
        this.start = start;
        this.end = end;
    }
    NFA.prototype.toString = function () {
        var processed = {};
        var stack = [this.start];
        var str = '';
        while (stack.length > 0) {
            var state = stack.pop();
            if (processed[state]) {
                continue;
            }
            processed[state] = 1;
            for (var i = 0; i < state.next.length; i++) {
                stack.push(state.next[i]);
            }
            str += state.toString();
        }
        return str;
    };
    return NFA;
}());
exports.NFA = NFA;
//# sourceMappingURL=Nfa.js.map